import classnames from "classnames";

export const BlueLink = ({ children, href, className = "", ...restProps }) => (
  <a
    href={href}
    target="_blank"
    rel="noreferrer"
    className={classnames("text-[#0196ff] underline", className)}
    {...restProps}
  >
    {children}
  </a>
);
